atomic-result-image {
  display: grid;
  place-items: center;
  grid-template-rows: 100%;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
